<template>
    <div class="card shadow-lg" :class="secure ? 'card-secure' : ''">
        <header v-if="icon || label" class="card-header d-flex justify-content-between align-content-center text-uppercase bg-light" :class="icon || label ? 'p-2' : 'p-0'">
            <span class="my-auto" v-if="icon || label">
                <fa-icon v-if="icon" :icon="icon"></fa-icon>
                <strong class="ml-1">{{ label }}</strong>
            </span>
            <slot name="header"></slot>
        </header>
        <main class="card-body p-0 position-relative">
            <span v-if="secure" class="secure-icon"><fa-icon :icon="['fas', 'lock']" /></span>
            <slot></slot>
        </main>
        <footer>
          <slot name="footer"></slot>
        </footer>
    </div>
</template>

<script>
export default {
  name: 'BSCard',
  props: ['icon', 'label', 'secure']
}
</script>

<style lang="scss">
    .card-header {
        font-size: 0.875rem;
    }

    .card-body {
        .secure-icon {
            svg {
                font-size: 7rem;
                position: absolute;
                bottom: 0;
                left: -30px;
                opacity: 0.2;
            }

            ~ * {
               position: relative;
               z-index: 1;
            }
        }
    }
</style>
